var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9197_14565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.47274 3.79354C6.27014 3.90755 4.21082 4.82445 2.63085 6.40445C0.939361 8.09591 0.0078125 10.337 0.0078125 12.7149V16L1.19784 13.2567C2.5878 10.487 5.40653 8.65072 8.47274 8.47989V12.2657L15.9923 6.12358L8.47274 0V3.79354ZM9.40982 4.7185V1.97161L14.5096 6.12467L9.40982 10.2903V7.52973H8.94128C7.16465 7.52973 5.42 8.02928 3.896 8.97436C2.74189 9.69006 1.75859 10.6336 1.00377 11.742C1.48505 7.78973 4.86119 4.7185 8.94128 4.7185H9.40982Z",
    fill: "#373F41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9197_14565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/IconShare.f165caada9845d3cc9d37856d7fb7ea4.svg";
export { ForwardRef as ReactComponent };